function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5.5a8 8 0 110 16 8 8 0 010-16zm0 3.7a.7.7 0 00-.7.7v4.3a.7.7 0 00.7.7h3.3a.7.7 0 100-1.4H9.2V4.9a.7.7 0 00-.7-.7z",
  fill: "#8F90A6"
});

function SvgAgentTimeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAgentTimeFilled;